import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import B2BOrganisationForm from './B2BOrganisationForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditB2BOrganisationScreen() {
  const { id } = useParams();

  if (!id) return;

  const api = Api.Organisation.useReadItem(id);

  if (!api.data) return <SoloLoading />;

  const organisation = api.data;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Organisation"
          items={[
            { name: 'B2B', url: '/b2b' },
            { name: organisation.name, url: `/b2b/${organisation.id}` },
            { name: 'Edit' },
          ]}
        />

        <B2BOrganisationForm existing={organisation} />
      </Stack>
    </ScreenWrap>
  );
}
